/**
 * Remove the first item from the array that matches the given value. This mutates the source array.
 *
 * @param arr - The source array to remove the item from
 * @param value - The value to search for an remove
 * @returns TRUE if an item was removed, FALSE otherwise
 */
export function remove<T>(arr: T[], value: T): boolean {
    const index = arr.indexOf(value);
    if (index > -1) {
        arr.splice(index, 1);
        return true;
    } else {
        return false;
    }
}
